import VideoPlayerSection from '@components/VideoPlayer';
import { Box, Typography } from '@mui/material';
import {
  OUR_STORY_PAGE_VIDEO_URL,
  OUR_STORY_PAGE_VIDEO_URL_MOBILE,
  OUR_STORY_PAGE_POSTER_IMAGE_URL,
} from '@utils/data';
import theme from 'src/style-system/theme';

const MeetOurTeam = () => {
  return (
    <Box>
      <Box
        bgcolor="cinnamon.main"
        p={{ xs: '63px 0', lg: '73px 0' }}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Typography
          variant="h1"
          align="center"
          color="whitePepper.main"
          maxWidth={{ xs: '100px', sm: '100%' }}
        >
          Meet Our Team
        </Typography>
      </Box>
      <Box
        sx={{
          height: '600px',
          backgroundColor: 'whitePepper.main',
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        }}
      >
        <VideoPlayerSection
          videoUrl={OUR_STORY_PAGE_VIDEO_URL}
          autoPlay={false}
          posterImgUrl={OUR_STORY_PAGE_POSTER_IMAGE_URL}
          height="600px"
        />
      </Box>
      <Box
        sx={{
          height: '600px',
          backgroundColor: 'whitePepper.main',
          [theme.breakpoints.up('sm')]: {
            display: 'none',
          },
        }}
      >
        <VideoPlayerSection
          videoUrl={OUR_STORY_PAGE_VIDEO_URL_MOBILE}
          posterImgUrl={OUR_STORY_PAGE_POSTER_IMAGE_URL}
          autoPlay={false}
        />
      </Box>
    </Box>
  );
};

export default MeetOurTeam;
